!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).htmlToImage={})}(this,(function(t){"use strict";function e(t,e,n,r){return new(n||(n=Promise))((function(i,o){function u(t){try{a(r.next(t))}catch(t){o(t)}}function c(t){try{a(r.throw(t))}catch(t){o(t)}}function a(t){var e;t.done?i(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e)}))).then(u,c)}a((r=r.apply(t,e||[])).next())}))}function n(t,e){var n,r,i,o,u={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function c(c){return function(a){return function(c){if(n)throw new TypeError("Generator is already executing.");for(;o&&(o=0,c[0]&&(u=0)),u;)try{if(n=1,r&&(i=2&c[0]?r.return:c[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,c[1])).done)return i;switch(r=0,i&&(c=[2&c[0],i.value]),c[0]){case 0:case 1:i=c;break;case 4:return u.label++,{value:c[1],done:!1};case 5:u.label++,r=c[1],c=[0];continue;case 7:c=u.ops.pop(),u.trys.pop();continue;default:if(!(i=u.trys,(i=i.length>0&&i[i.length-1])||6!==c[0]&&2!==c[0])){u=0;continue}if(3===c[0]&&(!i||c[1]>i[0]&&c[1]<i[3])){u.label=c[1];break}if(6===c[0]&&u.label<i[1]){u.label=i[1],i=c;break}if(i&&u.label<i[2]){u.label=i[2],u.ops.push(c);break}i[2]&&u.ops.pop(),u.trys.pop();continue}c=e.call(t,u)}catch(t){c=[6,t],r=0}finally{n=i=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}}var r,i=(r=0,function(){return r+=1,"u".concat("0000".concat((Math.random()*Math.pow(36,4)<<0).toString(36)).slice(-4)).concat(r)});function o(t){for(var e=[],n=0,r=t.length;n<r;n++)e.push(t[n]);return e}var u=null;function c(t){return void 0===t&&(t={}),u||(u=t.includeStyleProperties?t.includeStyleProperties:o(window.getComputedStyle(document.documentElement)))}function a(t,e){var n=(t.ownerDocument.defaultView||window).getComputedStyle(t).getPropertyValue(e);return n?parseFloat(n.replace("px","")):0}function s(t,e){void 0===e&&(e={});var n,r,i,o=e.width||(r=a(n=t,"border-left-width"),i=a(n,"border-right-width"),n.clientWidth+r+i),u=e.height||function(t){var e=a(t,"border-top-width"),n=a(t,"border-bottom-width");return t.clientHeight+e+n}(t);return{width:o,height:u}}var l=16384;function f(t,e){return void 0===e&&(e={}),t.toBlob?new Promise((function(n){t.toBlob(n,e.type?e.type:"image/png",e.quality?e.quality:1)})):new Promise((function(n){for(var r=window.atob(t.toDataURL(e.type?e.type:void 0,e.quality?e.quality:void 0).split(",")[1]),i=r.length,o=new Uint8Array(i),u=0;u<i;u+=1)o[u]=r.charCodeAt(u);n(new Blob([o],{type:e.type?e.type:"image/png"}))}))}function h(t){return new Promise((function(e,n){var r=new Image;r.onload=function(){r.decode().then((function(){requestAnimationFrame((function(){return e(r)}))}))},r.onerror=n,r.crossOrigin="anonymous",r.decoding="async",r.src=t}))}function d(t){return e(this,void 0,void 0,(function(){return n(this,(function(e){return[2,Promise.resolve().then((function(){return(new XMLSerializer).serializeToString(t)})).then(encodeURIComponent).then((function(t){return"data:image/svg+xml;charset=utf-8,".concat(t)}))]}))}))}function v(t,r,i){return e(this,void 0,void 0,(function(){var e,o,u;return n(this,(function(n){return e="http://www.w3.org/2000/svg",o=document.createElementNS(e,"svg"),u=document.createElementNS(e,"foreignObject"),o.setAttribute("width","".concat(r)),o.setAttribute("height","".concat(i)),o.setAttribute("viewBox","0 0 ".concat(r," ").concat(i)),u.setAttribute("width","100%"),u.setAttribute("height","100%"),u.setAttribute("x","0"),u.setAttribute("y","0"),u.setAttribute("externalResourcesRequired","true"),o.appendChild(u),u.appendChild(t),[2,d(o)]}))}))}var p=function(t,e){if(t instanceof e)return!0;var n=Object.getPrototypeOf(t);return null!==n&&(n.constructor.name===e.name||p(n,e))};function g(t,e,n,r){var i=".".concat(t,":").concat(e),o=n.cssText?function(t){var e=t.getPropertyValue("content");return"".concat(t.cssText," content: '").concat(e.replace(/'|"/g,""),"';")}(n):function(t,e){return c(e).map((function(e){var n=t.getPropertyValue(e),r=t.getPropertyPriority(e);return"".concat(e,": ").concat(n).concat(r?" !important":"",";")})).join(" ")}(n,r);return document.createTextNode("".concat(i,"{").concat(o,"}"))}function m(t,e,n,r){var o=window.getComputedStyle(t,n),u=o.getPropertyValue("content");if(""!==u&&"none"!==u){var c=i();try{e.className="".concat(e.className," ").concat(c)}catch(t){return}var a=document.createElement("style");a.appendChild(g(c,n,o,r)),e.appendChild(a)}}var w="application/font-woff",y="image/jpeg",b={woff:w,woff2:w,ttf:"application/font-truetype",eot:"application/vnd.ms-fontobject",png:"image/png",jpg:y,jpeg:y,gif:"image/gif",tiff:"image/tiff",svg:"image/svg+xml",webp:"image/webp"};function S(t){var e=function(t){var e=/\.([^./]*?)$/g.exec(t);return e?e[1]:""}(t).toLowerCase();return b[e]||""}function E(t){return-1!==t.search(/^(data:)/)}function x(t,e){return"data:".concat(e,";base64,").concat(t)}function C(t,r,i){return e(this,void 0,void 0,(function(){var e,o;return n(this,(function(n){switch(n.label){case 0:return[4,fetch(t,r)];case 1:if(404===(e=n.sent()).status)throw new Error('Resource "'.concat(e.url,'" not found'));return[4,e.blob()];case 2:return o=n.sent(),[2,new Promise((function(t,n){var r=new FileReader;r.onerror=n,r.onloadend=function(){try{t(i({res:e,result:r.result}))}catch(t){n(t)}},r.readAsDataURL(o)}))]}}))}))}var P={};function R(t,r,i){return e(this,void 0,void 0,(function(){var e,o,u,c,a;return n(this,(function(n){switch(n.label){case 0:if(e=function(t,e,n){var r=t.replace(/\?.*/,"");return n&&(r=t),/ttf|otf|eot|woff2?/i.test(r)&&(r=r.replace(/.*\//,"")),e?"[".concat(e,"]").concat(r):r}(t,r,i.includeQueryParams),null!=P[e])return[2,P[e]];i.cacheBust&&(t+=(/\?/.test(t)?"&":"?")+(new Date).getTime()),n.label=1;case 1:return n.trys.push([1,3,,4]),[4,C(t,i.fetchRequestInit,(function(t){var e=t.res,n=t.result;return r||(r=e.headers.get("Content-Type")||""),function(t){return t.split(/,/)[1]}(n)}))];case 2:return u=n.sent(),o=x(u,r),[3,4];case 3:return c=n.sent(),o=i.imagePlaceholder||"",a="Failed to fetch resource: ".concat(t),c&&(a="string"==typeof c?c:c.message),a&&console.warn(a),[3,4];case 4:return P[e]=o,[2,o]}}))}))}function T(t){return e(this,void 0,void 0,(function(){var e;return n(this,(function(n){return"data:,"===(e=t.toDataURL())?[2,t.cloneNode(!1)]:[2,h(e)]}))}))}function A(t,r){return e(this,void 0,void 0,(function(){var e,i,o,u;return n(this,(function(n){switch(n.label){case 0:return t.currentSrc?(e=document.createElement("canvas"),i=e.getContext("2d"),e.width=t.clientWidth,e.height=t.clientHeight,null==i||i.drawImage(t,0,0,e.width,e.height),[2,h(e.toDataURL())]):(o=t.poster,u=S(o),[4,R(o,u,r)]);case 1:return[2,h(n.sent())]}}))}))}function k(t,r){var i;return e(this,void 0,void 0,(function(){return n(this,(function(e){switch(e.label){case 0:return e.trys.push([0,3,,4]),(null===(i=null==t?void 0:t.contentDocument)||void 0===i?void 0:i.body)?[4,I(t.contentDocument.body,r,!0)]:[3,2];case 1:return[2,e.sent()];case 2:return[3,4];case 3:return e.sent(),[3,4];case 4:return[2,t.cloneNode(!1)]}}))}))}var L=function(t){return null!=t.tagName&&"SVG"===t.tagName.toUpperCase()};function N(t,e,n){return p(e,Element)&&(function(t,e,n){var r=e.style;if(r){var i=window.getComputedStyle(t);i.cssText?(r.cssText=i.cssText,r.transformOrigin=i.transformOrigin):c(n).forEach((function(n){var o=i.getPropertyValue(n);if("font-size"===n&&o.endsWith("px")){var u=Math.floor(parseFloat(o.substring(0,o.length-2)))-.1;o="".concat(u,"px")}p(t,HTMLIFrameElement)&&"display"===n&&"inline"===o&&(o="block"),"d"===n&&e.getAttribute("d")&&(o="path(".concat(e.getAttribute("d"),")")),r.setProperty(n,o,i.getPropertyPriority(n))}))}}(t,e,n),function(t,e,n){m(t,e,":before",n),m(t,e,":after",n)}(t,e,n),function(t,e){p(t,HTMLTextAreaElement)&&(e.innerHTML=t.value),p(t,HTMLInputElement)&&e.setAttribute("value",t.value)}(t,e),function(t,e){if(p(t,HTMLSelectElement)){var n=e,r=Array.from(n.children).find((function(e){return t.value===e.getAttribute("value")}));r&&r.setAttribute("selected","")}}(t,e)),e}function I(t,r,i){return e(this,void 0,void 0,(function(){return n(this,(function(u){return i||!r.filter||r.filter(t)?[2,Promise.resolve(t).then((function(t){return function(t,r){return e(this,void 0,void 0,(function(){return n(this,(function(e){return p(t,HTMLCanvasElement)?[2,T(t)]:p(t,HTMLVideoElement)?[2,A(t,r)]:p(t,HTMLIFrameElement)?[2,k(t,r)]:[2,t.cloneNode(L(t))]}))}))}(t,r)})).then((function(i){return function(t,r,i){var u,c;return e(this,void 0,void 0,(function(){var e;return n(this,(function(n){switch(n.label){case 0:return L(r)?[2,r]:(e=[],0===(e=null!=(a=t).tagName&&"SLOT"===a.tagName.toUpperCase()&&t.assignedNodes?o(t.assignedNodes()):p(t,HTMLIFrameElement)&&(null===(u=t.contentDocument)||void 0===u?void 0:u.body)?o(t.contentDocument.body.childNodes):o((null!==(c=t.shadowRoot)&&void 0!==c?c:t).childNodes)).length||p(t,HTMLVideoElement)?[2,r]:[4,e.reduce((function(t,e){return t.then((function(){return I(e,i)})).then((function(t){t&&r.appendChild(t)}))}),Promise.resolve())]);case 1:return n.sent(),[2,r]}var a}))}))}(t,i,r)})).then((function(e){return N(t,e,r)})).then((function(t){return function(t,r){return e(this,void 0,void 0,(function(){var e,i,o,u,c,a,s,l,f,h,d,v,p;return n(this,(function(n){switch(n.label){case 0:if(0===(e=t.querySelectorAll?t.querySelectorAll("use"):[]).length)return[2,t];i={},p=0,n.label=1;case 1:return p<e.length?(o=e[p],(u=o.getAttribute("xlink:href"))?(c=t.querySelector(u),a=document.querySelector(u),c||!a||i[u]?[3,3]:(s=i,l=u,[4,I(a,r,!0)])):[3,3]):[3,4];case 2:s[l]=n.sent(),n.label=3;case 3:return p++,[3,1];case 4:if((f=Object.values(i)).length){for(h="http://www.w3.org/1999/xhtml",(d=document.createElementNS(h,"svg")).setAttribute("xmlns",h),d.style.position="absolute",d.style.width="0",d.style.height="0",d.style.overflow="hidden",d.style.display="none",v=document.createElementNS(h,"defs"),d.appendChild(v),p=0;p<f.length;p++)v.appendChild(f[p]);t.appendChild(d)}return[2,t]}}))}))}(t,r)}))]:[2,null]}))}))}var D=/url\((['"]?)([^'"]+?)\1\)/g,H=/url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g,M=/src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;function F(t,r,i,o,u){return e(this,void 0,void 0,(function(){var e,c,a,s;return n(this,(function(n){switch(n.label){case 0:return n.trys.push([0,5,,6]),e=i?function(t,e){if(t.match(/^[a-z]+:\/\//i))return t;if(t.match(/^\/\//))return window.location.protocol+t;if(t.match(/^[a-z]+:/i))return t;var n=document.implementation.createHTMLDocument(),r=n.createElement("base"),i=n.createElement("a");return n.head.appendChild(r),n.body.appendChild(i),e&&(r.href=e),i.href=t,i.href}(r,i):r,c=S(r),a=void 0,u?[4,u(e)]:[3,2];case 1:return s=n.sent(),a=x(s,c),[3,4];case 2:return[4,R(e,c,o)];case 3:a=n.sent(),n.label=4;case 4:return[2,t.replace((l=r,f=l.replace(/([.*+?^${}()|\[\]\/\\])/g,"\\$1"),new RegExp("(url\\(['\"]?)(".concat(f,")(['\"]?\\))"),"g")),"$1".concat(a,"$3"))];case 5:return n.sent(),[3,6];case 6:return[2,t]}var l,f}))}))}function V(t){return-1!==t.search(D)}function q(t,r,i){return e(this,void 0,void 0,(function(){var e,o;return n(this,(function(n){return V(t)?(e=function(t,e){var n=e.preferredFontFormat;return n?t.replace(M,(function(t){for(;;){var e=H.exec(t)||[],r=e[0],i=e[2];if(!i)return"";if(i===n)return"src: ".concat(r,";")}})):t}(t,i),o=function(t){var e=[];return t.replace(D,(function(t,n,r){return e.push(r),t})),e.filter((function(t){return!E(t)}))}(e),[2,o.reduce((function(t,e){return t.then((function(t){return F(t,e,r,i)}))}),Promise.resolve(e))]):[2,t]}))}))}function U(t,r,i){var o;return e(this,void 0,void 0,(function(){var e,u;return n(this,(function(n){switch(n.label){case 0:return(e=null===(o=r.style)||void 0===o?void 0:o.getPropertyValue(t))?[4,q(e,null,i)]:[3,2];case 1:return u=n.sent(),r.style.setProperty(t,u,r.style.getPropertyPriority(t)),[2,!0];case 2:return[2,!1]}}))}))}function j(t,r){return e(this,void 0,void 0,(function(){var e,i;return n(this,(function(n){switch(n.label){case 0:return[4,U("background",t,r)];case 1:return n.sent()?[3,3]:[4,U("background-image",t,r)];case 2:n.sent(),n.label=3;case 3:return[4,U("mask",t,r)];case 4:return(i=n.sent())?[3,6]:[4,U("-webkit-mask",t,r)];case 5:i=n.sent(),n.label=6;case 6:return(e=i)?[3,8]:[4,U("mask-image",t,r)];case 7:e=n.sent(),n.label=8;case 8:return e?[3,10]:[4,U("-webkit-mask-image",t,r)];case 9:n.sent(),n.label=10;case 10:return[2]}}))}))}function O(t,r){return e(this,void 0,void 0,(function(){var e,i,o;return n(this,(function(n){switch(n.label){case 0:return(e=p(t,HTMLImageElement))&&!E(t.src)||p(t,SVGImageElement)&&!E(t.href.baseVal)?[4,R(i=e?t.src:t.href.baseVal,S(i),r)]:[2];case 1:return o=n.sent(),[4,new Promise((function(n,i){t.onload=n,t.onerror=r.onImageErrorHandler?function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];try{n(r.onImageErrorHandler.apply(r,t))}catch(t){i(t)}}:i;var u=t;u.decode&&(u.decode=n),"lazy"===u.loading&&(u.loading="eager"),e?(t.srcset="",t.src=o):t.href.baseVal=o}))];case 2:return n.sent(),[2]}}))}))}function B(t,r){return e(this,void 0,void 0,(function(){var e,i;return n(this,(function(n){switch(n.label){case 0:return e=o(t.childNodes),i=e.map((function(t){return z(t,r)})),[4,Promise.all(i).then((function(){return t}))];case 1:return n.sent(),[2]}}))}))}function z(t,r){return e(this,void 0,void 0,(function(){return n(this,(function(e){switch(e.label){case 0:return p(t,Element)?[4,j(t,r)]:[3,4];case 1:return e.sent(),[4,O(t,r)];case 2:return e.sent(),[4,B(t,r)];case 3:e.sent(),e.label=4;case 4:return[2]}}))}))}var W={};function $(t){return e(this,void 0,void 0,(function(){var e,r;return n(this,(function(n){switch(n.label){case 0:return null!=(e=W[t])?[2,e]:[4,fetch(t)];case 1:return[4,n.sent().text()];case 2:return r=n.sent(),e={url:t,cssText:r},W[t]=e,[2,e]}}))}))}function G(t,r){return e(this,void 0,void 0,(function(){var i,o,u,c,a=this;return n(this,(function(s){return i=t.cssText,o=/url\(["']?([^"')]+)["']?\)/g,u=i.match(/url\([^)]+\)/g)||[],c=u.map((function(u){return e(a,void 0,void 0,(function(){var e;return n(this,(function(n){return(e=u.replace(o,"$1")).startsWith("https://")||(e=new URL(e,t.url).href),[2,C(e,r.fetchRequestInit,(function(t){var e=t.result;return i=i.replace(u,"url(".concat(e,")")),[u,e]}))]}))}))})),[2,Promise.all(c).then((function(){return i}))]}))}))}function _(t){if(null==t)return[];for(var e=[],n=t.replace(/(\/\*[\s\S]*?\*\/)/gi,""),r=new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})","gi");;){if(null===(u=r.exec(n)))break;e.push(u[0])}n=n.replace(r,"");for(var i=/@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi,o=new RegExp("((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})","gi");;){var u;if(null===(u=i.exec(n))){if(null===(u=o.exec(n)))break;i.lastIndex=o.lastIndex}else o.lastIndex=i.lastIndex;e.push(u[0])}return e}function J(t,r){return e(this,void 0,void 0,(function(){var e,i;return n(this,(function(n){return e=[],i=[],t.forEach((function(e){if("cssRules"in e)try{o(e.cssRules||[]).forEach((function(t,n){if(t.type===CSSRule.IMPORT_RULE){var o=n+1,u=$(t.href).then((function(t){return G(t,r)})).then((function(t){return _(t).forEach((function(t){try{e.insertRule(t,t.startsWith("@import")?o+=1:e.cssRules.length)}catch(e){console.error("Error inserting rule from remote css",{rule:t,error:e})}}))})).catch((function(t){console.error("Error loading remote css",t.toString())}));i.push(u)}}))}catch(o){var n=t.find((function(t){return null==t.href}))||document.styleSheets[0];null!=e.href&&i.push($(e.href).then((function(t){return G(t,r)})).then((function(t){return _(t).forEach((function(t){n.insertRule(t,n.cssRules.length)}))})).catch((function(t){console.error("Error loading remote stylesheet",t)}))),console.error("Error inlining remote css file",o)}})),[2,Promise.all(i).then((function(){return t.forEach((function(t){if("cssRules"in t)try{o(t.cssRules||[]).forEach((function(t){e.push(t)}))}catch(e){console.error("Error while reading CSS rules from ".concat(t.href),e)}})),e}))]}))}))}function Q(t){return t.filter((function(t){return t.type===CSSRule.FONT_FACE_RULE})).filter((function(t){return V(t.style.getPropertyValue("src"))}))}function X(t,r){return e(this,void 0,void 0,(function(){return n(this,(function(e){switch(e.label){case 0:if(null==t.ownerDocument)throw new Error("Provided element is not within a Document");return[4,J(o(t.ownerDocument.styleSheets),r)];case 1:return[2,Q(e.sent())]}}))}))}function K(t){return t.trim().replace(/["']/g,"")}function Y(t,r){return e(this,void 0,void 0,(function(){var e,i;return n(this,(function(n){switch(n.label){case 0:return[4,X(t,r)];case 1:return e=n.sent(),i=function(t){var e=new Set;return function t(n){(n.style.fontFamily||getComputedStyle(n).fontFamily).split(",").forEach((function(t){e.add(K(t))})),Array.from(n.children).forEach((function(e){e instanceof HTMLElement&&t(e)}))}(t),e}(t),[4,Promise.all(e.filter((function(t){return i.has(K(t.style.fontFamily))})).map((function(t){var e=t.parentStyleSheet?t.parentStyleSheet.href:null;return q(t.cssText,e,r)})))];case 2:return[2,n.sent().join("\n")]}}))}))}function Z(t,r){return e(this,void 0,void 0,(function(){var e,i,o,u,c;return n(this,(function(n){switch(n.label){case 0:return null==r.fontEmbedCSS?[3,1]:(i=r.fontEmbedCSS,[3,5]);case 1:return r.skipFonts?(o=null,[3,4]):[3,2];case 2:return[4,Y(t,r)];case 3:o=n.sent(),n.label=4;case 4:i=o,n.label=5;case 5:return(e=i)&&(u=document.createElement("style"),c=document.createTextNode(e),u.appendChild(c),t.firstChild?t.insertBefore(u,t.firstChild):t.appendChild(u)),[2]}}))}))}function tt(t,r){return void 0===r&&(r={}),e(this,void 0,void 0,(function(){var e,i,o,u;return n(this,(function(n){switch(n.label){case 0:return e=s(t,r),i=e.width,o=e.height,[4,I(t,r,!0)];case 1:return[4,Z(u=n.sent(),r)];case 2:return n.sent(),[4,z(u,r)];case 3:return n.sent(),function(t,e){var n=t.style;e.backgroundColor&&(n.backgroundColor=e.backgroundColor),e.width&&(n.width="".concat(e.width,"px")),e.height&&(n.height="".concat(e.height,"px"));var r=e.style;null!=r&&Object.keys(r).forEach((function(t){n[t]=r[t]}))}(u,r),[4,v(u,i,o)];case 4:return[2,n.sent()]}}))}))}function et(t,r){return void 0===r&&(r={}),e(this,void 0,void 0,(function(){var e,i,o,u,c,a,f,d,v;return n(this,(function(n){switch(n.label){case 0:return e=s(t,r),i=e.width,o=e.height,[4,tt(t,r)];case 1:return[4,h(n.sent())];case 2:return u=n.sent(),c=document.createElement("canvas"),a=c.getContext("2d"),f=r.pixelRatio||function(){var t,e;try{e=process}catch(t){}var n=e&&e.env?e.env.devicePixelRatio:null;return n&&(t=parseInt(n,10),Number.isNaN(t)&&(t=1)),t||window.devicePixelRatio||1}(),d=r.canvasWidth||i,v=r.canvasHeight||o,c.width=d*f,c.height=v*f,r.skipAutoScale||function(t){(t.width>l||t.height>l)&&(t.width>l&&t.height>l?t.width>t.height?(t.height*=l/t.width,t.width=l):(t.width*=l/t.height,t.height=l):t.width>l?(t.height*=l/t.width,t.width=l):(t.width*=l/t.height,t.height=l))}(c),c.style.width="".concat(d),c.style.height="".concat(v),r.backgroundColor&&(a.fillStyle=r.backgroundColor,a.fillRect(0,0,c.width,c.height)),a.drawImage(u,0,0,c.width,c.height),[2,c]}}))}))}t.getFontEmbedCSS=function(t,r){return void 0===r&&(r={}),e(this,void 0,void 0,(function(){return n(this,(function(e){return[2,Y(t,r)]}))}))},t.toBlob=function(t,r){return void 0===r&&(r={}),e(this,void 0,void 0,(function(){return n(this,(function(e){switch(e.label){case 0:return[4,et(t,r)];case 1:return[4,f(e.sent())];case 2:return[2,e.sent()]}}))}))},t.toCanvas=et,t.toJpeg=function(t,r){return void 0===r&&(r={}),e(this,void 0,void 0,(function(){return n(this,(function(e){switch(e.label){case 0:return[4,et(t,r)];case 1:return[2,e.sent().toDataURL("image/jpeg",r.quality||1)]}}))}))},t.toPixelData=function(t,r){return void 0===r&&(r={}),e(this,void 0,void 0,(function(){var e,i,o,u;return n(this,(function(n){switch(n.label){case 0:return e=s(t,r),i=e.width,o=e.height,[4,et(t,r)];case 1:return u=n.sent(),[2,u.getContext("2d").getImageData(0,0,i,o).data]}}))}))},t.toPng=function(t,r){return void 0===r&&(r={}),e(this,void 0,void 0,(function(){return n(this,(function(e){switch(e.label){case 0:return[4,et(t,r)];case 1:return[2,e.sent().toDataURL()]}}))}))},t.toSvg=tt}));

if (!window.htmlToImage && typeof exports === "object") window.htmlToImage = exports;
if (!window.htmlToImage && typeof module === "object" && module.exports) window.htmlToImage = module.exports;

(function () {
  const root = document.querySelector("[data-snack-quiz]");
  if (!root) return;

  const questions = [
    {
      key: "opening",
      label: "Opening style",
      question: "When you open a fresh bag, what’s your plan?",
      options: [
        { label: "Save some for tomorrow", value: 1 },
        { label: "Just a few", value: 2 },
        { label: "Half the bag", value: 3 },
        { label: "No plan. Good luck.", value: 4 },
      ],
    },
    {
      key: "sharing",
      label: "Sharing style",
      question: "Someone asks for a gummy. You...",
      options: [
        { label: "Share a few", value: 2 },
        { label: "Count them first", value: 3 },
        { label: "Hand over the bag", value: 4 },
        { label: "Pretend you didn’t hear", value: 1 },
      ],
    },
    {
      key: "last",
      label: "Last gummy",
      question: "Your bag is almost empty.",
      options: [
        { label: "Save the last one", value: 1 },
        { label: "Split it in half", value: 2 },
        { label: "Eat it immediately", value: 3 },
        { label: "Already ordering more", value: 4 },
      ],
    },
    {
      key: "found",
      label: "Found extra bag",
      question: "You find a forgotten bag in your drawer.",
      options: [
        { label: "Jackpot", value: 3 },
        { label: "Nice surprise", value: 2 },
        { label: "Gone in 60 seconds", value: 4 },
        { label: "Check expiration date first", value: 1 },
      ],
    },
  ];

  const state = {
    answers: Array(questions.length).fill(null),
    index: 0,
    printed: false,
  };

  const counterEl = root.querySelector("[data-quiz-counter]");
  const questionEl = root.querySelector("[data-quiz-question]");
  const optionsEl = root.querySelector("[data-quiz-options]");
  const dotsEl = root.querySelector("[data-quiz-dots]");
  const receiptEl = root.querySelector("[data-quiz-receipt]");
  const prevButton = root.querySelector("[data-quiz-prev]");
  const nextButton = root.querySelector("[data-quiz-next]");
  const saveButton = root.querySelector("[data-save-receipt]");
  let autoAdvanceTimer = null;

  const clearAutoAdvance = () => {
    if (!autoAdvanceTimer) return;
    window.clearTimeout(autoAdvanceTimer);
    autoAdvanceTimer = null;
  };

  const animateQuestion = (direction = 1) => {
    const panel = root.querySelector(".snack-quiz__panel");
    if (!panel) return;
    panel.style.setProperty("--question-shift", `${direction * 22}px`);
    panel.classList.remove("is-entering");
    void panel.offsetWidth;
    panel.classList.add("is-entering");
    window.setTimeout(() => panel.classList.remove("is-entering"), 420);
  };

  const escapeHtml = (value) =>
    String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");

  const formatDate = () => {
    const date = new Date();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${month}.${day}.${date.getFullYear()}`;
  };

  const getSubjectId = (answers) => {
    const date = new Date();
    const year = String(date.getFullYear()).slice(-2);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const seed = answers.reduce((sum, answer, index) => sum + (answer?.value || 0) * (index + 7) * 41, 246);
    return `#${year}${month}${day}-${String(3000 + (seed % 6000)).padStart(4, "0")}`;
  };

  const profiles = [
    {
      key: "saver",
      letter: "A.",
      name: "The Saver",
      result: "A. THE SAVER",
      line: "Thoughtful, prepared, and secretly very proud of it.",
      image: window.TwoFourSixAssets.receiptSaver,
      metrics: [
        ["Chew speed", 42],
        ["Self control", 88],
        ["Restock instinct", 36],
      ],
      action: "Save one for later.",
      note: "Future you is impressed.",
    },
    {
      key: "negotiator",
      letter: "B.",
      name: "The Negotiator",
      result: "B. THE NEGOTIATOR",
      line: "Logical, charming, and great at bargaining with yourself.",
      image: window.TwoFourSixAssets.receiptNegotiator,
      metrics: [
        ["Chew speed", 64],
        ["Self control", 53],
        ["Restock instinct", 71],
      ],
      action: "Make a snack treaty.",
      note: "Terms may change mid-chew.",
    },
    {
      key: "enthusiast",
      letter: "C.",
      name: "The Enthusiast",
      result: "C. THE ENTHUSIAST",
      line: "Focused, committed, and always all-in.",
      image: window.TwoFourSixAssets.receiptEnthusiast,
      metrics: [
        ["Chew speed", 91],
        ["Self control", 18],
        ["Restock instinct", 97],
      ],
      action: "Grab another bag.",
      note: "You know you want to.",
    },
    {
      key: "strategist",
      letter: "D.",
      name: "The Strategist",
      result: "D. THE STRATEGIST",
      line: "Organized, prepared, and never caught off guard.",
      image: window.TwoFourSixAssets.receiptStrategist,
      metrics: [
        ["Chew speed", 76],
        ["Self control", 68],
        ["Restock instinct", 93],
      ],
      action: "Build the backup stash.",
      note: "This is not your first drawer.",
    },
  ];

  const getAnswer = (questionIndex) => {
    const answerIndex = state.answers[questionIndex];
    if (answerIndex === null) return null;
    return questions[questionIndex].options[answerIndex];
  };

  const isComplete = () => state.answers.every((answer) => answer !== null);

  const getReport = () => {
    const answers = questions.map((_, index) => getAnswer(index));
    const total = answers.reduce((sum, answer) => sum + (answer?.value || 0), 0);
    const answeredCount = answers.filter(Boolean).length;
    const completionRatio = answeredCount / questions.length;
    const chewRisk = Math.round((total / 16) * 100 * completionRatio);
    const chewSpeed = Math.min(99, Math.max(0, Math.round((answers[0]?.value || 0) * 17 + (answers[2]?.value || 0) * 8)));
    const selfControl = Math.max(1, Math.round(100 - total * 5.6));
    const survival = Math.max(7, Math.round(94 - total * 5.1));
    const restock = total >= 13 ? "CRITICAL" : total >= 10 ? "HIGH" : total >= 7 ? "WATCH" : answeredCount ? "LOW" : "...";
    const status =
      total >= 13
        ? "RESTOCK ADVISED BEFORE OPENING NEXT BAG"
        : total >= 10
          ? "MONITOR BAG LEVELS CLOSELY"
          : total >= 7
            ? "CHEW ACTIVITY WITHIN NORMAL CHAOS"
            : answeredCount
              ? "LOW RISK, SUSPICIOUSLY ORGANIZED"
              : "AWAITING SNACK DATA";

    let profile = profiles[0];
    if (total >= 13) {
      profile = profiles[2];
    } else if (total >= 10) {
      profile = profiles[3];
    } else if (total >= 7) {
      profile = profiles[1];
    }

    return {
      answers,
      answeredCount,
      chewRisk,
      chewSpeed,
      selfControl,
      survival,
      restock,
      status,
      total,
      profile,
      subjectId: getSubjectId(answers),
    };
  };

  const renderOptions = () => {
    const question = questions[state.index];
    optionsEl.innerHTML = question.options
      .map((option, optionIndex) => {
        const checked = state.answers[state.index] === optionIndex ? " checked" : "";
        return `
          <label class="snack-quiz__option">
            <input type="radio" name="snack-question" value="${optionIndex}"${checked}>
            <span>${escapeHtml(option.label)}</span>
          </label>
        `;
      })
      .join("");
  };

  const renderDots = () => {
    dotsEl.innerHTML = questions
      .map((_, index) => {
        const classes = ["snack-quiz__dot"];
        if (index === state.index) classes.push("is-active");
        if (state.answers[index] !== null) classes.push("is-complete");
        return `<span class="${classes.join(" ")}"></span>`;
      })
      .join("");
  };

  const renderReceipt = () => {
    const report = getReport();
    const profile = report.profile;
    const titleParts = profile.result.split(" THE ");
    const metricRows = profile.metrics
      .map(([label, value]) => {
        const meterBlocks = 5;
        const filledBlocks = Math.max(0, Math.min(meterBlocks, Math.round(value / (100 / meterBlocks))));
        const blocks = Array.from({ length: meterBlocks }, (_, index) => `<span class="snack-receipt__meter-block${index < filledBlocks ? " is-filled" : ""}"></span>`).join("");
        return `
          <div class="snack-receipt__metric">
            <span class="snack-receipt__metric-icon"></span>
            <span class="snack-receipt__metric-label">${escapeHtml(label)}</span>
            <span class="snack-receipt__meter">${blocks}</span>
            <strong>${value}%</strong>
          </div>
        `;
      })
      .join("");

    receiptEl.innerHTML = `
      <div class="snack-receipt__top-marks"><span>= =</span><div class="snack-receipt__logo" role="img" aria-label="twofoursix"></div><span>= =</span></div>
      <div class="snack-receipt__rule"></div>
      <div class="snack-receipt__meta">
        <div><span>Subject ID</span><strong>${escapeHtml(report.subjectId)}</strong></div>
        <div><span>Date</span><strong>${formatDate()}</strong></div>
      </div>
      <div class="snack-receipt__rule"></div>
      <div class="snack-receipt__section-label">Result</div>
      <div class="snack-receipt__result">
        <strong class="snack-receipt__result-title">${titleParts[1] ? `<mark>THE ${escapeHtml(titleParts[1])}</mark>` : `<mark>${escapeHtml(profile.name.toUpperCase())}</mark>`}</strong>
        <div class="snack-receipt__result-body">
          <img src="${profile.image}" alt="${escapeHtml(profile.name)}" loading="lazy">
          <p>${escapeHtml(profile.line)}</p>
        </div>
      </div>
      <div class="snack-receipt__rule"></div>
      <div class="snack-receipt__section-label">Chew profile</div>
      <div class="snack-receipt__metrics">${metricRows}</div>
      <div class="snack-receipt__rule"></div>
      <div class="snack-receipt__section-label">Recommended action</div>
      <div class="snack-receipt__action">${escapeHtml(profile.action)}</div>
      <div class="snack-receipt__rule"></div>
      <div class="snack-receipt__thanks">Thank you for chewing.</div>
      <div class="snack-receipt__barcode" aria-hidden="true"></div>
    `;

    root.classList.toggle("is-printed", state.printed);
    receiptEl.setAttribute("aria-hidden", state.printed ? "false" : "true");
    saveButton.disabled = !isComplete() || !state.printed;
  };

  const render = ({ animate = false, direction = 1 } = {}) => {
    const question = questions[state.index];
    counterEl.textContent = `Q${state.index + 1} / ${questions.length}`;
    questionEl.textContent = question.question;
    prevButton.disabled = state.index === 0;
    nextButton.textContent = state.index === questions.length - 1 ? "PRINT" : "NEXT ->";
    renderOptions();
    renderDots();
    renderReceipt();
    if (animate) animateQuestion(direction);
  };

  const goToNext = () => {
    clearAutoAdvance();

    if (state.index < questions.length - 1) {
      state.index += 1;
      render({ animate: true, direction: 1 });
      return;
    }

    const firstMissing = state.answers.findIndex((answer) => answer === null);
    if (firstMissing >= 0) {
      state.index = firstMissing;
      render({ animate: true, direction: -1 });
      return;
    }

    state.printed = true;
    renderReceipt();
    saveButton.focus({ preventScroll: true });
  };

  const loadImage = (src) =>
    new Promise((resolve) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => resolve(null);
      image.src = src;
    });

  const drawReceiptImage = async () => {
    if (document.fonts?.ready) await document.fonts.ready;

    const report = getReport();
    const profile = report.profile;
    const profileImage = await loadImage(profile.image);
    const logoImage = await loadImage(window.TwoFourSixAssets.logo);
    const canvas = document.createElement("canvas");
    const width = 1080;
    const height = 1920;
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");

    const receipt = { x: 125, y: 170, w: 830, h: 1580 };
    ctx.fillStyle = "#F6BE3B";
    ctx.fillRect(0, 0, width, height);
    ctx.strokeStyle = "#171310";
    ctx.lineWidth = 10;
    ctx.strokeRect(34, 34, width - 68, height - 68);
    ctx.fillStyle = "#171310";
    ctx.font = "900 38px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";
    ctx.textAlign = "center";
    ctx.fillText("SNACK REPORT // BATCH 246", width / 2, 102);
    ctx.font = "900 30px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";
    ctx.fillText("@THETWOFOURSIX", width / 2, 1848);

    ctx.fillStyle = "#FFF9EB";
    ctx.shadowColor = "rgba(23, 19, 16, 0.16)";
    ctx.shadowBlur = 24;
    ctx.shadowOffsetY = 14;
    ctx.beginPath();
    ctx.moveTo(receipt.x, receipt.y + 24);
    for (let x = receipt.x; x <= receipt.x + receipt.w; x += 28) {
      ctx.lineTo(x + 14, receipt.y);
      ctx.lineTo(x + 28, receipt.y + 24);
    }
    ctx.lineTo(receipt.x + receipt.w, receipt.y + receipt.h - 34);
    for (let x = receipt.x + receipt.w; x >= receipt.x; x -= 28) {
      ctx.lineTo(x - 14, receipt.y + receipt.h);
      ctx.lineTo(x - 28, receipt.y + receipt.h - 34);
    }
    ctx.closePath();
    ctx.fill();
    ctx.shadowColor = "transparent";

    const center = receipt.x + receipt.w / 2;
    const left = receipt.x + 58;
    const right = receipt.x + receipt.w - 58;
    let y = receipt.y + 76;

    const setFont = (size, weight = 800) => {
      ctx.font = `${weight} ${size}px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace`;
      ctx.fillStyle = "#171310";
    };

    const fitFontSize = (text, maxWidth, startSize, minSize = 22, weight = 900) => {
      let size = startSize;
      setFont(size, weight);
      while (size > minSize && ctx.measureText(text).width > maxWidth) {
        size -= 2;
        setFont(size, weight);
      }
      return size;
    };

    const drawWrappedText = (text, x, startY, maxWidth, lineHeight, maxLines = 4) => {
      const words = text.split(" ");
      const lines = [];
      let currentLine = "";

      words.forEach((word) => {
        const nextLine = currentLine ? `${currentLine} ${word}` : word;
        if (currentLine && ctx.measureText(nextLine).width > maxWidth) {
          lines.push(currentLine);
          currentLine = word;
        } else {
          currentLine = nextLine;
        }
      });
      if (currentLine) lines.push(currentLine);

      lines.slice(0, maxLines).forEach((lineText, index) => {
        ctx.fillText(lineText, x, startY + index * lineHeight);
      });
    };

    const line = () => {
      ctx.setLineDash([18, 12]);
      ctx.beginPath();
      ctx.moveTo(left, y);
      ctx.lineTo(right, y);
      ctx.stroke();
      ctx.setLineDash([]);
      y += 42;
    };

    const centerText = (text, size, weight = 900) => {
      setFont(size, weight);
      ctx.textAlign = "center";
      ctx.fillText(text, center, y);
      y += size + 18;
    };

    const sectionLabel = (text) => {
      setFont(31, 900);
      ctx.fillStyle = "#003726";
      ctx.textAlign = "center";
      ctx.fillText(text.toUpperCase(), center, y);
      ctx.fillStyle = "#4F853D";
      ctx.textAlign = "left";
      ctx.fillText("≡", left + 4, y - 2);
      ctx.textAlign = "right";
      ctx.fillText("≡", right - 4, y - 2);
      y += 58;
    };

    setFont(34, 900);
    ctx.textAlign = "left";
    ctx.fillText("= =", left + 20, y + 22);
    ctx.textAlign = "right";
    ctx.fillText("= =", right - 20, y + 22);
    if (logoImage) {
      const logoW = 360;
      const logoH = logoW * (26 / 146);
      const logoCanvas = document.createElement("canvas");
      logoCanvas.width = logoW;
      logoCanvas.height = logoH;
      const logoCtx = logoCanvas.getContext("2d");
      logoCtx.drawImage(logoImage, 0, 0, logoW, logoH);
      logoCtx.globalCompositeOperation = "source-in";
      logoCtx.fillStyle = "#171310";
      logoCtx.fillRect(0, 0, logoW, logoH);
      ctx.drawImage(logoCanvas, center - logoW / 2, y - 2);
      y += logoH + 26;
    } else {
      centerText("TWOFORSIX", 58, 900);
    }
    line();

    setFont(29, 900);
    ctx.textAlign = "left";
    ctx.fillText("SUBJECT ID", left + 12, y);
    ctx.fillText(report.subjectId, left + 12, y + 42);
    ctx.beginPath();
    ctx.setLineDash([12, 10]);
    ctx.moveTo(center, y - 34);
    ctx.lineTo(center, y + 58);
    ctx.stroke();
    ctx.setLineDash([]);
    ctx.fillText("DATE", center + 60, y);
    ctx.fillText(formatDate(), center + 60, y + 42);
    y += 100;
    line();

    sectionLabel("Result");
    const titleParts = profile.result.split(" THE ");
    const resultName = titleParts[1] || profile.name.toUpperCase();
    setFont(76, 900);
    ctx.textAlign = "left";
    ctx.fillText("THE", left + 8, y + 68);
    const resultNameSize = fitFontSize(resultName, 370, 68, 46, 900);
    ctx.fillStyle = "#F6BE3B";
    ctx.fillRect(left + 4, y + 96, 390, resultNameSize + 12);
    ctx.fillStyle = "#171310";
    ctx.fillText(resultName, left + 8, y + 96 + resultNameSize);

    if (profileImage) {
      ctx.save();
      ctx.globalCompositeOperation = "multiply";
      ctx.drawImage(profileImage, right - 270, y + 18, 250, 250);
      ctx.restore();
    }

    setFont(27, 900);
    ctx.fillStyle = "#F6861F";
    ctx.textAlign = "left";
    drawWrappedText(profile.line.toUpperCase(), left + 18, y + 218, 365, 35, 4);
    y += 370;
    line();

    sectionLabel("Chew profile");
    profile.metrics.forEach(([label, value], metricIndex) => {
      const iconX = left + 24;
      const iconY = y - 22;
      ctx.fillStyle = "#4F853D";
      ctx.beginPath();
      ctx.arc(iconX, iconY, 31, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = "#171310";
      ctx.lineWidth = 4;
      ctx.stroke();
      setFont(18, 900);
      ctx.textAlign = "center";
      ctx.fillStyle = "#FFF8E6";
      ctx.fillText(metricIndex === 0 ? "S" : metricIndex === 1 ? "C" : "R", iconX, iconY + 7);

      setFont(24, 900);
      ctx.textAlign = "left";
      ctx.fillStyle = "#171310";
      ctx.fillText(label.toUpperCase(), left + 96, y - 10);
      const barX = left + 360;
      const filledBlocks = Math.round(value / 10);
      for (let i = 0; i < 10; i += 1) {
        ctx.strokeStyle = "#171310";
        ctx.lineWidth = 2;
        ctx.strokeRect(barX + i * 25, y - 34, 19, 22);
        if (i < filledBlocks) {
          ctx.fillStyle = "#171310";
          ctx.fillRect(barX + i * 25, y - 34, 19, 22);
        }
      }
      setFont(38, 900);
      ctx.textAlign = "right";
      ctx.fillText(`${value}%`, right - 8, y - 10);
      y += 90;
    });
    line();

    sectionLabel("Recommended action");
    ctx.fillStyle = "#F6BE3B";
    ctx.fillRect(left + 70, y - 18, right - left - 140, 62);
    fitFontSize(profile.action.toUpperCase(), right - left - 170, 50, 34, 900);
    ctx.textAlign = "center";
    ctx.fillText(profile.action.toUpperCase(), center, y + 28);
    y += 92;
    setFont(30, 900);
    ctx.fillText(profile.note.toUpperCase(), center, y);
    ctx.strokeStyle = "#F6861F";
    ctx.lineWidth = 5;
    ctx.beginPath();
    ctx.moveTo(center - 85, y + 24);
    ctx.lineTo(center + 85, y + 24);
    ctx.stroke();

    y += 64;
    line();
    setFont(28, 900);
    ctx.fillText("THANK YOU FOR CHEWING.", center, y);
    y += 40;
    ctx.fillStyle = "#171310";
    for (let x = center - 255; x < center + 255; x += 8) {
      const barHeight = 26 + ((x / 8) % 4) * 8;
      ctx.fillRect(x, y, 4, barHeight);
    }

    return canvas;
  };

  const blobToDataUrl = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  const assetToDataUrl = async (src) => {
    const response = await fetch(new URL(src, window.location.href));
    if (!response.ok) throw new Error(`Could not load receipt asset: ${src}`);
    return blobToDataUrl(await response.blob());
  };

  const copyRenderedStyles = (source, clone) => {
    const styles = getComputedStyle(source);
    for (const property of styles) clone.style.setProperty(property, styles.getPropertyValue(property), styles.getPropertyPriority(property));
    [...source.children].forEach((child, index) => copyRenderedStyles(child, clone.children[index]));
  };

  const capturePrintedReceipt = async () => {
    if (document.fonts?.ready) await document.fonts.ready;

    const width = receiptEl.offsetWidth;
    const height = receiptEl.scrollHeight;
    const clone = receiptEl.cloneNode(true);
    copyRenderedStyles(receiptEl, clone);

    clone.style.position = "static";
    clone.style.inset = "auto";
    clone.style.margin = "0";
    clone.style.opacity = "1";
    clone.style.transform = "none";
    clone.style.clipPath = "none";
    clone.style.transition = "none";
    clone.style.width = `${width}px`;
    clone.style.height = `${height}px`;
    clone.style.overflow = "hidden";

    const sectionLabels = [...clone.querySelectorAll(".snack-receipt__section-label")];
    sectionLabels.forEach((label) => {
      const text = label.textContent;
      label.textContent = "";
      label.innerHTML = `<span style="color:#4F853D;font-size:16px;line-height:.6">≡</span><span>${escapeHtml(text)}</span><span style="color:#4F853D;font-size:16px;line-height:.6">≡</span>`;
      label.style.justifyContent = "space-between";
    });

    const sourceImages = [...receiptEl.querySelectorAll("img")];
    const cloneImages = [...clone.querySelectorAll("img")];
    await Promise.all(sourceImages.map(async (image, index) => {
      cloneImages[index].src = await assetToDataUrl(image.currentSrc || image.src);
    }));

    const logo = clone.querySelector(".snack-receipt__logo");
    if (logo) {
      const logoImage = document.createElement("img");
      logoImage.src = await assetToDataUrl(window.TwoFourSixAssets.logo);
      logoImage.alt = "246";
      logoImage.style.cssText = `display:block;flex:none;width:${logo.offsetWidth}px;height:${logo.offsetHeight}px;object-fit:contain`;
      logo.replaceWith(logoImage);
    }

    const scale = 4;
    const markup = new XMLSerializer().serializeToString(clone);
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width * scale}" height="${height * scale}" viewBox="0 0 ${width} ${height}"><foreignObject width="100%" height="100%"><div xmlns="http://www.w3.org/1999/xhtml" style="width:${width}px;height:${height}px">${markup}</div></foreignObject></svg>`;
    const svgUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    const image = await new Promise((resolve, reject) => {
      const exportImage = new Image();
      const timeout = window.setTimeout(() => reject(new Error("Receipt render timed out")), 8000);
      exportImage.onload = () => {
        window.clearTimeout(timeout);
        resolve(exportImage);
      };
      exportImage.onerror = () => {
        window.clearTimeout(timeout);
        reject(new Error("Could not render the printed receipt"));
      };
      exportImage.src = svgUrl;
    });

    const canvas = document.createElement("canvas");
    canvas.width = width * scale;
    canvas.height = height * scale;
    const context = canvas.getContext("2d");
    context.scale(scale, scale);
    context.drawImage(image, 0, 0, width, height);
    return canvas;
  };

  optionsEl.addEventListener("change", (event) => {
    const input = event.target.closest("input[type='radio']");
    if (!input) return;
    clearAutoAdvance();
    const questionIndex = state.index;
    state.answers[state.index] = Number(input.value);
    state.printed = false;
    renderDots();
    renderReceipt();

    autoAdvanceTimer = window.setTimeout(() => {
      autoAdvanceTimer = null;
      if (state.index !== questionIndex) return;
      goToNext();
    }, 260);
  });

  prevButton.addEventListener("click", () => {
    clearAutoAdvance();
    if (state.index > 0) {
      state.index -= 1;
      state.printed = false;
      render({ animate: true, direction: -1 });
    }
  });

  nextButton.addEventListener("click", () => {
    clearAutoAdvance();
    goToNext();
  });

  const captureReceiptBlob = async () => {
    if (!window.htmlToImage?.toBlob) throw new Error("Receipt capture library is unavailable");
    if (document.fonts?.ready) await document.fonts.ready;

    const width = receiptEl.offsetWidth;
    const height = receiptEl.scrollHeight;
    return window.htmlToImage.toBlob(receiptEl, {
      cacheBust: true,
      pixelRatio: 4,
      width,
      height,
      backgroundColor: "#FFF8E6",
      style: {
        clipPath: "none",
        height: `${height}px`,
        inset: "auto",
        left: "auto",
        margin: "0",
        opacity: "1",
        overflow: "hidden",
        position: "static",
        top: "auto",
        transform: "none",
        transition: "none",
        width: `${width}px`,
      },
    });
  };

  saveButton.addEventListener("click", async () => {
    if (!isComplete() || !state.printed) return;
    const originalLabel = saveButton.textContent;
    saveButton.disabled = true;
    saveButton.textContent = "PRINTING YOUR RECEIPT...";
    try {
      const blob = await captureReceiptBlob();
      if (!blob) throw new Error("Receipt capture returned no image");
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.download = `twofoursix-chew-receipt-${Date.now()}.png`;
      link.href = url;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      window.setTimeout(() => {
        URL.revokeObjectURL(url);
        link.remove();
      }, 1000);
    } catch (error) {
      console.error("Could not capture the printed receipt:", error);
      saveButton.textContent = "PRINTER JAM — TRY AGAIN";
      window.setTimeout(() => { saveButton.textContent = originalLabel; }, 1800);
    } finally {
      saveButton.disabled = false;
    }
    if (saveButton.textContent === "PRINTING YOUR RECEIPT...") saveButton.textContent = originalLabel;
  });

  render();
})();
